import { Elements } from '@stripe/react-stripe-js';
import { CheckoutForm } from './CheckoutForm';
import { StripeCheckoutProps } from '../../types/Payment/StripeCheckoutProps';
import { loadStripe } from '@stripe/stripe-js';

// Make sure to call `loadStripe` outside of a component’s render to avoid recreating the `Stripe` object on every render.
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

export const StripeCheckout = (props: StripeCheckoutProps) => {
  const stripeOptions = {
    clientSecret: props.clientSecret,
    appearance: {
      // TODO: Add custom appearance options here if necessary
    },
  };
  return (
    <>
      <Elements stripe={stripePromise} options={stripeOptions}>
        <CheckoutForm
          patientId={props.patientId}
          amountPaid={props.amountPaid}
          couponCode={props.couponCode}
          discountApplied={props.discountApplied}
        />
      </Elements>
    </>
  );
};
